import { render } from "./HeroHeader.vue?vue&type=template&id=ebd8e40a&scoped=true"
import script from "./HeroHeader.vue?vue&type=script&lang=js"
export * from "./HeroHeader.vue?vue&type=script&lang=js"

import "./HeroHeader.vue?vue&type=style&index=0&id=ebd8e40a&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebd8e40a"]])

export default __exports__